import { render, staticRenderFns } from "./ProductBundleList.vue?vue&type=template&id=62f8da2c&"
import script from "./ProductBundleList.vue?vue&type=script&lang=js&"
export * from "./ProductBundleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports